import { useEffect, useState } from 'react'
import { Activity } from 'lucide-react'
import { fetchSignalLog, type LifeSignalLog } from '../lib/api'
import LifeModal from '../components/LifeModal'

export default function SignalLogSection() {
  const [log, setLog] = useState<LifeSignalLog | null>(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    fetchSignalLog().then(setLog)
  }, [])

  return (
    <section id="signal-log" className="scroll-mt-32 py-16">
      <header className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="text-4xl font-heading font-semibold amber-gradient-text">Signal Log</h2>
          <p className="text-amber-100/70 mt-1 max-w-prose">
            Notes from being human. What's on the mind right now — short, undated except for "now".
          </p>
        </div>
        <Activity className="text-amber-300/60" size={28} />
      </header>

      {log && (
        <>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="life-card-dark rounded-xl p-8 sm:p-12 text-left w-full block min-h-[220px]"
          >
            <div className="flex items-center justify-between mb-4 text-xs uppercase tracking-wider text-amber-200/70">
              <span>Latest</span>
              <span className="flex items-center gap-3">
                {log.location && <span>{log.location}</span>}
                {log.updated && <span>· {log.updated}</span>}
              </span>
            </div>
            <div
              className="prose prose-invert max-w-none text-amber-100/85 prose-headings:font-heading prose-headings:text-amber-100 prose-strong:text-amber-200 prose-a:text-amber-300 line-clamp-4"
              dangerouslySetInnerHTML={{ __html: log.content_html }}
            />
            <p className="mt-4 text-sm text-amber-300/80">Read full →</p>
          </button>

          <LifeModal isOpen={open} onClose={() => setOpen(false)} title="Signal Log">
            <div className="p-6 space-y-4">
              <div className="flex items-center justify-between text-sm text-amber-200/80">
                {log.location && <span>{log.location}</span>}
                {log.updated && <span>{log.updated}</span>}
              </div>
              <div
                className="prose prose-invert max-w-none text-amber-100/85 prose-headings:font-heading prose-headings:text-amber-100 prose-strong:text-amber-200 prose-a:text-amber-300"
                dangerouslySetInnerHTML={{ __html: log.content_html }}
              />
            </div>
          </LifeModal>
        </>
      )}
    </section>
  )
}
